angular.module('v3sWbtPlayerApp').factory('v3sScormDataBrowserService', ["localStorageService", "v3sCompressionService", "v3sServiceFinder", "v3sUserService", "v3sLog", "v3sChangeCheckerService", "v3sWbtVarService", "v3sNavigationService", function (localStorageService, v3sCompressionService, v3sServiceFinder, v3sUserService, v3sLog, v3sChangeCheckerService, v3sWbtVarService, v3sNavigationService) {
    var v3sWbtSettingsService = v3sServiceFinder.get("v3sWbtSettingsService");

    var itemData = null;
    var secureId = "";
    var location = "";
    var lastVisit = NaN;

    var changeChecker = null;

    function load(data) {
        v3sLog.debug("Browser Adapter is selected. Loading ScormData...");

        itemData = data;
        try {
            secureId = itemData.id + "#" + v3sCompressionService.md5(window.location.pathname);

            var scormData = localStorageService.get(secureId);
            if (!scormData) { //load data with old id
                scormData = localStorageService.get(itemData.id);
            }

            if (!!scormData) {
                scormData = v3sCompressionService.decompress(scormData);

                if (!!scormData) {
                    if (!angular.isArray(scormData)) {

                        itemData.setGlobalScormData(scormData.scoStatus);
                        if (v3sWbtSettingsService) v3sWbtSettingsService.set(scormData.settings);
                        v3sUserService.setUserScormData(scormData.user);
                        v3sWbtVarService.setVars(scormData.vars);

                        location = scormData.location;
                        lastVisit = scormData.lastChange;

                        v3sLog.debug("BrowserScormAdapter loaded ScormData as object", scormData);
                    } else if (scormData.length > 1) {
                        //obsolete
                        itemData.setScormData(scormData[0]);
                        if (v3sWbtSettingsService) v3sWbtSettingsService.set(scormData[1]);
                        v3sUserService.setUserScormData(scormData[2]);
                        v3sWbtVarService.setVars(scormData[3]);

                        var visitData = !!scormData[4] ? scormData[4] : { location: "", lastChange: NaN };
                        location = visitData.location;
                        lastVisit = visitData.lastChange;

                        v3sLog.debug("BrowserScormAdapter loaded old ScormData as array", scormData);
                    }
                }
            }

        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
            v3sLog.error("general.scormdatanotloaded", "Could not load learning progress from browser, corrupted data");
        }

        initChangeChecker();

        return true;
    }


    
    function getLocation() {
        return location;
    }

    function getLastVisit() {
        return lastVisit * 1000;
    }

    function save() {
        var saved = false;

        if (!!changeChecker) {
            saved = changeChecker.saveChanges();
        }

        return saved;
    }

    function initChangeChecker() {
        changeChecker = new v3sChangeCheckerService([itemData, v3sUserService, v3sWbtSettingsService]);
        changeChecker.start(
            function saveCallback() {
                v3sLog.debug("BrowserScormAdapter is saving ScormData");

                var saved = false;

                try {
                    var scormData = {};
                    scormData.scoStatus = itemData.getGlobalScormData();
                    if (v3sWbtSettingsService) scormData.settings = v3sWbtSettingsService.get();
                    scormData.user = v3sUserService.getUserScormData();
                    scormData.vars = v3sWbtVarService.getVars();
                    scormData.lastChange = Math.floor((new Date()).getTime() / 1000);
                    scormData.location = v3sNavigationService.getLastPageId();
                    
                    v3sLog.debug("ScormData", scormData);

                    scormData = v3sCompressionService.compress(scormData);
                    v3sLog.debug("Compressed ScormData", scormData);

                    localStorageService.set(secureId, scormData);

                    if (localStorageService.get(secureId) != scormData) {
                        throw "localStorageService could not correctly save the data.";
                    }

                    saved = true;

                    v3sLog.debug("BrowserScormAdapter saved ScormData");

                    if (!changeChecker.isLastSaved()) { //Erfolgsmeldung nur dann anzeigen, falls vorher Fehler auftratt
                        v3sLog.close("scormdatanotsaved");
                        v3sLog.success("general.scormdatasaved", true);
                    }
                } catch (e) {
                    v3sLog.close("general.scormdatasaved");
                    v3sLog.warn("Exception: ", false, e);
                    v3sLog.error("general.scormdatanotsaved", "Could not save ScormData to the browser", { time: Math.floor(changeChecker.geTimeSinceLastSave() / 1000 + 2) });
                }

                return saved;
            },
            1000);
    }

    function close(forced) {

        var closed = false;

        v3sLog.debug("BrowserScormAdapter is closing...");

        if (!!changeChecker) {
            changeChecker.setForcedChange();
            changeChecker.saveChanges();
            if (forced || changeChecker.isLastSaved()) {
                changeChecker.stop();
                changeChecker = null;
                closed = true;
            }
        }

        v3sLog.debug("BrowserScormAdapter closed", closed);

        return closed;
    }

    function reset() {
        changeChecker.stop();
        changeChecker = null;
        localStorageService.set(secureId, "");
    }

    return {
        load: load,
        getLocation: getLocation,
        getEntry: function () { return "" },
        getLastVisit: getLastVisit,
        close: close,
        save: save,
        reset: reset
    }
}]);